import { useState } from "react";
import { styled } from "@mui/material";
import { Outlet } from "react-router-dom";

import { Footer } from "../components/layout/Footer";
import { Header } from "../components/layout/Header";
import { Navigation } from "../components/navigation/Navigation";
import { useLayoutContext } from "../hooks/routingHooks";

interface Props {}

export function AppLayout(props: Props) {
  const { settings, config } = useLayoutContext();
  const [headerActionsContainer, setHeaderActionsContainer] =
    useState<Element | null>(null);

  return render();

  function render() {
    return (
      <Styles>
        <Header
          setActionsContainer={setHeaderActionsContainer}
          config={config}
        />
        <Navigation className="navigation" config={config} />
        {headerActionsContainer && (
          <Outlet
            context={{
              settings,
              config,
              actionsContainer: headerActionsContainer,
            }}
          />
        )}
        <Footer className="footer" />
      </Styles>
    );
  }
}

const Styles = styled("div")`
  flex: 1 0 100%;
  display: grid;
  grid-template-columns: ${({ theme }) => `${theme.spacing(8)} 1fr`};
  grid-template-rows: ${({ theme }) =>
    `${theme.spacing(8)} 1fr ${theme.spacing(4)}`};
  grid-template-areas:
    "header header"
    "navigation content"
    "footer footer";

  header {
    grid-area: header;
  }
  .navigation {
    grid-area: navigation;
  }
  .footer {
    grid-area: footer;
  }
`;
